

const Faculty=()=>{
   
   
}
export default Faculty;